import cafeBakery from './templates/cafe-bakery.json' with { type: 'json' };
import restaurantBar from './templates/restaurant-bar.json' with { type: 'json' };
import studioPortfolio from './templates/studio-portfolio.json' with { type: 'json' };
import localServices from './templates/local-services.json' with { type: 'json' };
import salonWellness from './templates/salon-wellness.json' with { type: 'json' };
import eventCommunity from './templates/event-community.json' with { type: 'json' };
import designsManifest from './templates/designs.json' with { type: 'json' };
import blank from './templates/blank.json' with { type: 'json' };
const designCategoryByNumber = {
    '01': 'Food & Drink',
    '02': 'Food & Drink',
    '03': 'Travel & Leisure',
    '04': 'Professional Services',
    '05': 'Shops',
    '06': 'Automotive',
    '07': 'Shops',
    '08': 'Shops',
    '09': 'Health & Fitness',
    '10': 'Food & Drink',
    '11': 'Shops',
    '12': 'Home & Garden',
    '13': 'Shops',
    '14': 'Health & Fitness',
    '15': 'Food & Drink',
    '16': 'Professional Services',
    '17': 'Travel & Leisure',
    '18': 'Shops',
    '19': 'Food & Drink',
    '20': 'Creative',
    '21': 'Food & Drink',
    '22': 'Property',
    '23': 'Tech & Online',
    '24': 'Creative',
    '25': 'Professional Services',
    '26': 'Health & Fitness',
    '27': 'Local Services',
    '28': 'Community & Events',
    '29': 'Community & Events',
    '30': 'Education',
    '31': 'Creative',
    '32': 'Creative',
    '33': 'Beauty & Wellness',
    '34': 'Pets & Animals',
    '35': 'Food & Drink',
    '36': 'Food & Drink',
    '37': 'Shops',
    '38': 'Creative',
    '39': 'Health & Fitness',
    '40': 'Travel & Leisure',
    '41': 'Community & Events',
    '42': 'Education',
    '43': 'Community & Events',
    '44': 'Automotive',
    '45': 'Creative',
    '46': 'Tech & Online',
    '47': 'Local Services',
    '48': 'Creative',
    '49': 'Professional Services',
    '50': 'Beauty & Wellness',
    '51': 'Education',
    '52': 'Food & Drink',
    '53': 'Health & Fitness',
    '54': 'Professional Services',
    '55': 'Shops',
    '56': 'Beauty & Wellness',
    '57': 'Food & Drink',
    '58': 'Home & Garden',
    '59': 'Food & Drink',
    '60': 'Travel & Leisure',
    '61': 'Pets & Animals',
    '62': 'Beauty & Wellness',
    '63': 'Community & Events'
};
export const designManifest = designsManifest;
const designedTemplates = designsManifest.map((entry) => {
    const number = entry.id.slice(-2);
    const firstDelimiter = entry.title.search(/\s*—\s*|\s*\|\s*/);
    const name = firstDelimiter === -1 ? entry.title.trim() : entry.title.slice(0, firstDelimiter).trim();
    return {
        id: entry.id,
        name,
        description: entry.description,
        kind: 'designed',
        previewImage: `/template-previews/${entry.id}.jpg`,
        category: designCategoryByNumber[number] ?? 'Shops',
        site: {
            version: 1,
            meta: { title: entry.title, description: entry.description, language: 'en' },
            theme: {
                name: cafeBakery.theme.name,
                palette: { ...cafeBakery.theme.palette },
                fonts: { ...cafeBakery.theme.fonts },
                radius: { ...cafeBakery.theme.radius },
                spacing: { ...cafeBakery.theme.spacing }
            },
            blocks: [
                {
                    id: 'design',
                    type: 'designed',
                    props: { designId: entry.id, texts: {}, vars: {} }
                }
            ]
        }
    };
});
const templateDefinitions = [
    {
        id: 'blank',
        name: 'Blank page',
        description: 'Start from an empty canvas and build your page block by block. Includes a guided tutorial.',
        category: 'Start from scratch',
        site: blank
    },
    {
        id: 'cafe-bakery',
        name: 'Cafe & Bakery',
        description: 'Warm, generous and built for daily regulars. Serif headings, soft paper and a menu that reads like a kitchen counter.',
        previewImage: '/template-previews/cafe-bakery.jpg',
        site: cafeBakery
    },
    {
        id: 'restaurant-bar',
        name: 'Restaurant & Bar',
        description: 'Dark, moody and confident. Big type, sharp edges and a layout that gives dishes and drinks room to breathe.',
        previewImage: '/template-previews/restaurant-bar.jpg',
        site: restaurantBar
    },
    {
        id: 'studio-portfolio',
        name: 'Studio & Portfolio',
        description: 'Minimal and image-led. A calm grid with strong typography for work that speaks for itself.',
        previewImage: '/template-previews/studio-portfolio.jpg',
        site: studioPortfolio
    },
    {
        id: 'local-services',
        name: 'Local Services',
        description: 'Clear, trustworthy and blue. Built to help a local services business look reliable from first click to call.',
        previewImage: '/template-previews/local-services.jpg',
        site: localServices
    },
    {
        id: 'salon-wellness',
        name: 'Salon & Wellness',
        description: 'Soft, airy and calm. Rounded corners and gentle colours make a health or beauty practice feel welcoming.',
        previewImage: '/template-previews/salon-wellness.jpg',
        site: salonWellness
    },
    {
        id: 'event-community',
        name: 'Event & Community',
        description: 'Bold and colourful. A flexible community layout with high-energy sections and a social-first finish.',
        previewImage: '/template-previews/event-community.jpg',
        site: eventCommunity
    },
    ...designedTemplates
];
export const templates = templateDefinitions;
export function getTemplateById(id) {
    return templateDefinitions.find((template) => template.id === id);
}
//# sourceMappingURL=templates.js.map